import Cookies from 'js-cookie'

const token = 'Tengen_token'
const baseToken = 'Tengen_base_token'
const tokenExpires = 'Tengen_token_expires'
const baseTokenExpires = 'Tengen_base_token_expires'

function parseExpiresTime (expiresTime) {
  if (!expiresTime) return null
  if (typeof expiresTime === 'number') {
    return expiresTime < 100000000000 ? expiresTime * 1000 : expiresTime
  }

  const timestamp = Date.parse(String(expiresTime).replace(' ', 'T'))
  return Number.isNaN(timestamp) ? null : timestamp
}

function setTokenWithExpires (tokenKey, expiresKey, value, expiresTime) {
  Cookies.set(tokenKey, value)
  const expiresTimestamp = parseExpiresTime(expiresTime)
  if (expiresTimestamp) {
    Cookies.set(expiresKey, String(expiresTimestamp))
  } else {
    Cookies.remove(expiresKey)
  }
}

function getValidToken (tokenKey, expiresKey) {
  const value = Cookies.get(tokenKey)
  const expiresTimestamp = Number(Cookies.get(expiresKey))
  if (value && expiresTimestamp && expiresTimestamp <= Date.now()) {
    Cookies.remove(tokenKey)
    Cookies.remove(expiresKey)
    return undefined
  }
  return value
}

export function getToken () {
  return getValidToken(token, tokenExpires)
}

export function setToken (value, expiresTime) {
  return setTokenWithExpires(token, tokenExpires, value, expiresTime)
}

export function removeToken () {
  Cookies.remove(token)
  Cookies.remove(tokenExpires)
}

export function getBaseToken () {
  return getValidToken(baseToken, baseTokenExpires)
}

export function setBaseToken (value, expiresTime) {
  return setTokenWithExpires(baseToken, baseTokenExpires, value, expiresTime)
}

export function removeBaseToken () {
  Cookies.remove(baseToken)
  Cookies.remove(baseTokenExpires)
}
